module.exports = __webpack_public_path__ + "static/media/3.86c97836.JPG";